import React, { useCallback, useEffect, useMemo } from "react";
import PersonalDataBox from "../components/checkout/PersonalDataBox";
import PaymentMethodBox from "../components/checkout/PaymentMethodBox";
import OrderSummaryBox from "../components/checkout/OrderSummaryBox";
import WhatsAppSupport from "../components/checkout/WhatsAppSupport";
import Header from "../components/checkout/Header";
import { useOidcAuth } from "../auth/OidcAuthProvider";
import { useMediaQuery } from "../hooks/useMediaQuery";
import gtag from "ga-gtag";
import { fetchProfile } from "@/utils/encrypt";

const CheckoutGlobalPage: React.FC = () => {
  const { user, loginWithPassword, logout } = useOidcAuth();
  const isMobile = useMediaQuery("(max-width: 767px)");

  const isLoggedIn = !!(user && user.access_token);
  const userName =
    user?.profile?.name || user?.profile?.preferred_username || "";

  const userEmail = useMemo(() => {
    return user?.profile?.email || "";
  }, [user]);


  const productId = process.env["APP_PRODUCT_ID_GLOBAL"] || "";

  const paymentItem = {
    id: productId,
    title: "DIO Global Vitalício",
    quantity: 1,
    unitPrice: 59880,
  };

  useEffect(() => {}, [isLoggedIn, user]);

  const handlePasswordLogin = useCallback(
    async (email: string, password: string) => {
      try {
        const success = await loginWithPassword(email, password);
        return success;
      } catch (error) {
        console.error("Error during password login:", error);
        return false;
      }
    },
    [loginWithPassword]
  );

  const handleLogout = useCallback(async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Error during logout:", error);
    }
  }, [logout]);

  useEffect(() => {
    const encryptProfile = fetchProfile(user?.access_token || "", "global");
    const event = {
      product: "global_vitalicio",
      item_id: "global_vitalicio",
      item_name: "GLOBAL VITALÍCIO",
      affiliation: "plano",
      pageType: "internal",
      ...encryptProfile
    };
    gtag("event", "checkout_begin", event);
  }, [gtag, user]);

  const logo = useCallback(
    () => (
      <img
        src="https://hermes.dio.me/assets/products/full/global-lifetime.svg"
        alt="DIO Pro Vitalício"
        className="w-64 h-auto mx-auto"
      />
    ),
    []
  );

  return (
    <div className="min-h-screen bg-[#F7F9FB] flex flex-col justify-start">
      <Header
        defaultLogoUrl={
          isMobile
            ? "https://hermes.dio.me/assets/products/full/global-lifetime.svg"
            : "https://hermes.dio.me/assets/diome/logo-full.svg"
        }
      />
      <div className="flex justify-center items-start py-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-x-8 lg:gap-y-0 w-full max-w-6xl">
          <div className={`${isLoggedIn ? "order-3 lg:order-1" : "order-1"}`}>
            <PersonalDataBox
              isLoggedIn={isLoggedIn}
              userName={userName}
              userEmail={userEmail}
              onLoginAttempt={handlePasswordLogin}
              onLogout={handleLogout}
            />
          </div>
          <div className="order-2">
            <PaymentMethodBox
              user={user}
              isLoggedIn={isLoggedIn}
              onLogout={handleLogout}
              paymentItem={paymentItem}
              product="global"
            />
          </div>
          <div
            className={`${
              isLoggedIn ? "order-1 lg:order-3" : "order-2 lg:order-3"
            }`}
          >
            <OrderSummaryBox
              logo={logo}
              planName="Vitalício"
              productPrice="R$ 2998,80"
              discount="-R$ 2400,00"
              total="R$ 598,80"
              installment="12x R$ 49,90"
              features={[
                "Acesso ao curso de inglês para profissionais de tecnologia.",
                "Acesso ao Job Board com as melhores vagas internacionais.",
                "Acesso a mentorias de preparação para processos seletivos em inglês com experts globais.",
                "Acesso garantido às acelerações internacionais.",
                "Acesso ilimitado ao DIO PRO.",
                "Acesso ao AI Job Hunter com 10.000 créditos, indicação diária de vagas com score de compatibilidade e feedback personalizado por vaga.",
                "Acesso ao Agente de IA que adapta seu currículo ao ATS, gera o Raio-X de cada vaga e mostra o passo a passo de evolução para chegar preparado na entrevista.",
                "Acesso ao Preparatório de entrevista que reproduz uma situação real com recrutadores e feedback personalizado sobre o seu desempenho na entrevista.",
                "Cancelamento grátis em 7 dias.",
              ]}
            />
          </div>
        </div>
      </div>

      {!isMobile && (
        <WhatsAppSupport
          delay={5000}
          name="Raquel Leão"
          message="Olá! 😊&#10;Precisa de ajuda para realizar sua matrícula?"
        />
      )}
    </div>
  );
};

export default CheckoutGlobalPage;
